<section
  infiniteScroll
  [infiniteScrollDisabled]="!moreGroupsAvailable"
  [immediateCheck]="true"
  (scrolled)="loadAllGroups(true)"
>
  <div class="l_flex m-l_flex">
    <div>
      <h2
        class="h2 font-semibold guts-m-t-1-half guts-m-b-quart guts-p-h-1-quart"
      >
        {{ groupsHeader }}
      </h2>
      <p class="par--light par--small guts-m-b-3 guts-p-h-1-quart">
        {{ i18n.ProfileCtrl_GroupsDescription }}
      </p>
    </div>
    <div
      class="
        l_flex
        m-l_flex
        l_flex-top-children
        guts-m-t-1-half guts-p-h-1-quart
      "
    >
      <button
        *ngIf="orgId"
        (click)="goBrowseGroups()"
        df-button
        dfButtonType="secondary"
        data-dgat="profile-groups-49b"
        class="guts-m-r-half"
        [attr.aria-label]="i18n.A11y_BrowseGroups"
      >
        {{ i18n.Core_Browse }}
      </button>
      <button
        *ngIf="hasGroupCreatePermissions"
        (click)="addGroup($event)"
        df-button
        dfButtonType="primary"
        data-dgat="profile-groups-46d"
        [attr.aria-label]="i18n.A11y_CreateGroup"
      >
        <div class="l_flexbar gap-full-half">
          <df-icon icon="plus"></df-icon>
          <div>{{ i18n.Core_Create }}</div>
        </div>
      </button>
    </div>
  </div>

  <ul *ngIf="!isLoading" class="grid">
    <li
      class="grid__col-xs-6 grid__col-sm-4"
      *ngFor="let group of groups; let i = index"
      dgxIntersectionObserver
      (onIntersection)="onIntersectionOfGroup(group, i)"
      data-dgat="profileGroups-d59"
    >
      <div class="tile__wrapper" data-dgat="profileGroups-5fb">
        <dgx-group-tile [group]="group"></dgx-group-tile>
      </div>
    </li>
  </ul>
  <div *ngIf="loadingGroups || isLoading">
    <ul class="grid">
      <li
        class="grid__col-xs-6 grid__col-sm-4"
        *ngFor="let i of [1, 2, 3, 4, 5, 6]"
        data-dgat="profileGroups-da2"
      >
        <dgx-skeleton type="group"></dgx-skeleton>
      </li>
    </ul>
  </div>
</section>
<div
  class="center-text guts-m-t-2"
  *ngIf="!groups.length && !loadingGroups && !isLoading"
>
  <dgx-profile-empty-state
    [title]="i18n.GroupCtrl_EmptyStateTitle"
    [description]="i18n.GroupCtrl_EmptyStateDescription"
  ></dgx-profile-empty-state>
</div>
<div class="footer-glasses"></div>
